import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
  Router,
  NavigationEnd,
  ActivatedRoute,
  Data,
  RouterModule,
} from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { CoreService } from '../../../../../../src/app/services/core.service';

// Removed unused ApexCharts from breadcrumb (charts were commented out) 28/10/2026 DW
@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './breadcrumb.component.html',
  styleUrls: [],
})
export class AppBreadcrumbComponent {
  // Default hidden so browse refresh never flashes breadcrumbs before route data 03/11/2026 DW
  // pageInfo: Data | any = Object.create(null);
  pageInfo: Data | any = { hideBreadcrumb: true };

  options = this.settings.getOptions();

  constructor(
    private settings: CoreService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        })
      )
      .pipe(filter((route) => route.outlet === 'primary'))
      .pipe(mergeMap((route) => route.data))
      .subscribe((event) => {
        if (event?.['title']) {
          this.titleService.setTitle(event['title']);
        }
        this.pageInfo = event;
      });

    // Seed current route data (e.g. Home hideBreadcrumb) 28/10/2026 DW
    let route = this.activatedRoute;
    while (route?.firstChild) {
      route = route.firstChild;
    }
    const current = route?.snapshot?.data;
    if (current && Object.keys(current).length) {
      this.pageInfo = current;
      if (current['title']) {
        this.titleService.setTitle(current['title']);
      }
    }
  }
}
